import classNames from 'classnames';

const Credits = ({ component, className }) => (
  <dl className={classNames('credits', className)}>
    {component.authors.map((author, index) => (
      <div className="credits__author" key={index}>
        <dt className="t-tiny">{author.role}</dt>
        <dd className="t-tiny">{author.name}</dd>
      </div>
    ))}
  </dl>
);

export default Credits;
